export const SUCCESS = 'Success';
export const ERROR = 'Error';
export const WARNING = 'Warning';
export const DEFAULT = '';
